import React from 'react';
import classNames from 'classnames';
import config from '../../common/config';

export default ({
  name,
  imageUrl,
  license,
  facilityName,
  state,
  category,
  cbdContent,
  cbdContentUnitOfMeasure,
  cbdContentDose,
  cbdContentDoseUnitOfMeasure,
  cbdPotency,
  thcContent,
  thcContentUnitOfMeasure,
  thcContentDose,
  thcContentDoseUnitOfMeasure,
  thcPotency,
  retailAvailability,
  className,
  onClick = () => {},
  onKeyDown = (e) => { if (e.keyCode === 13) onClick(); },
}) => (
  <div className={classNames('item-list-result', className)} onClick={onClick} onKeyDown={onKeyDown} role='button' tabIndex={0}>
    <div className="row">
      <div className="col-8 col-md-4 d-flex align-items-center justify-content-start">
        <div className="row ms-2">
          <div className="col-3 d-flex align-items-center justify-content-center p-0">
            <div className="text-center">
              <img src={`${config.imageServerUrl}${imageUrl}`} alt={name} className="w-100" />
            </div>
          </div>
          <div className="col-9">
            <div className="name">
              {name}
              <div className="category">{category}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-4 col-md-8">
        <div className="row">
          <div className="facility d-none d-xl-block col-3">
            <div>Facility</div>
            {facilityName}
          </div>
          <div className="license d-none d-xl-block col-2">
            <div>License</div>
            {license}
            {retailAvailability && <div>(+{retailAvailability.length})</div>}
          </div>
          <div className="state col-6 col-md-2 col-xl-1">
            <div>State</div>
            {state}
          </div>
          <div className="cbd d-none d-md-block col">
            {(cbdContent || cbdContentDose || cbdPotency || thcContent || thcContentDose || thcPotency) && <div>Potency</div>}
            <div className="row mr-0">
              <div className="col-12 col-xl-6 mr-0">
                {thcPotency && `THC: ${thcPotency}%`}
              </div>
              <div className="col-6 mr-0">
                {cbdPotency && `CBD: ${cbdPotency}%`}
              </div>
            </div>
            <div className="row mr-0">
              <div className="col-6 mr-0">
                {thcContent && `THC: ${thcContent}`}{thcContentUnitOfMeasure && `${thcContentUnitOfMeasure}`}{thcContent && <br />}
              </div>
              <div className="col-6 mr-0">
                {cbdContent && `CBD: ${cbdContent}`}{cbdContentUnitOfMeasure && `${cbdContentUnitOfMeasure}`}{cbdContent && <br />}
              </div>
            </div>
            <div className="row mr-0">
              <div className="col-6 mr-0">
                {thcContentDose && `THC Dose: ${thcContentDose}`}{thcContentDoseUnitOfMeasure && `${thcContentDoseUnitOfMeasure}`}{thcContentDose && <br />}
              </div>
              <div className="col-6 mr-0">
                {cbdContentDose && `CBD Dose: ${cbdContentDose}`}{cbdContentDoseUnitOfMeasure && `${cbdContentDoseUnitOfMeasure}`}{cbdContentDose && <br />}
              </div>              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
